import { render, staticRenderFns } from "./indexsc.vue?vue&type=template&id=487f96a2&"
import script from "./indexsc.vue?vue&type=script&lang=js&"
export * from "./indexsc.vue?vue&type=script&lang=js&"
import style0 from "./indexsc.vue?vue&type=style&index=0&id=487f96a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports